<template>
<div class="chapter">
<div class="inner_page">
<div class="contentsPage" id="d7e155">
<h3 class="toc" style="margin-left:-.4em;">
<i>Contents</i>
</h3>
<p class="contentsDiv">
<a href="#/_9781440506963_epub_c1#c1">Foreword</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/_9781440506963_epub_c2#c2">Introduction</a>
<br/>
</p>
<p class="contentsDiv">
<span href="#/_9781440506963_epub_c3#c3" title="Link target outside of Sample">
<b>Appendix A:</b> Recommended Resources</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/_9781440506963_epub_c4#c4" title="Link target outside of Sample">
<b>Appendix B:</b> The 101 Secrets Every Woman Should Know</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/_9781440506963_epub_c6#c6" title="Link target outside of Sample">About the Authors</span>
<br/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// _9781440506963_epub_toc.vue?7b2067ec